import { render, staticRenderFns } from "./SearchBarFilters.vue?vue&type=template&id=ca4dcc44&scoped=true&"
import script from "./SearchBarFilters.vue?vue&type=script&lang=js&"
export * from "./SearchBarFilters.vue?vue&type=script&lang=js&"
import style0 from "./SearchBarFilters.vue?vue&type=style&index=0&id=ca4dcc44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca4dcc44",
  null
  
)

export default component.exports